
import { serialize } from '../../../utils/functions';

const ProjectService = {
    fetchData(query) {
        let p = serialize(query);
        return axios.get(window.baseUrl + '/projects?' + p);
    },
    fetch(slug) {
        return axios.get(window.baseUrl + '/project/' + slug);
    },
    fetchTechnologies() {
        return axios.get(window.baseUrl + '/technologies');
    },
    fetchTags() {
        return axios.get(window.baseUrl + '/tags');
    },
    fetchTypes() {
        return axios.get(window.baseUrl + '/types');
    },
    fetchCategories() {
        return axios.get(window.baseUrl + '/categories');
    },
    fetchSearchOptions() {
        return axios.get(window.baseUrl + '/searchOptions');
    },
};

export { ProjectService };


// WEBPACK FOOTER //
// ./resources/js/store/modules/Projects/service.js